// External modules
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { cloneDeep, isEmpty, filter } from 'lodash';
import _ from 'lodash';
import Pagination from 'rc-pagination';
import acHTTPClient from 'services/ACHTTPClient';

import 'rc-pagination/assets/index.css';

// Internal modules
import SetRoute from '../molecules/planners/SetRoute';
import SetVirtual from '../molecules/planners/SetVirtual';
import SetStop from '../molecules/routes/SetStop';
import { default as SetSparkStop } from '../molecules/virtuals/SetStop';
import { getSparks } from '../common/actions/sparks';
import { getChallengesBySparkId } from '../common/actions/challenges';
import { getCluesBySparkId } from '../common/actions/clues';
import Bookings from '../molecules/planners/Bookings';
import {
  getBookings,
  getBookingNotificationData,
  postPreviewConfirmation,
  postSendConfirmation,
  postSendCode,
  patchBooking,
  putBookingItemPrice,
  patchComponentStopProviderItem,
  postBookingItemPayment,
  postBookingItemActivity,
  postBookingNotification,
  patchStopBookingNote,
  putBookingManager,
  deleteBookingManager,
  putBookingStop,
  patchBookingPublishable,
  deleteOneBookingRoute,
  deleteOneBookingVirtual,
  patchBookingNote,
  putBookingDeliveryStatus,
  postBookingMarkAvailable,
  deleteOneBookingStopProvider,
  deleteOneBookingStopSpark,
  patchBookingStopsOrder,
  clearBookingError,
  patchBookingPublished,
  putBookingIsPersonalised,
} from '../common/actions/bookings';
import { getStoryboardsByProviderId } from 'components/common/actions/storyboards';
import { getUsers } from '../common/actions/users';
import { getRoutesByProductId, getRoute } from '../common/actions/routes';
import {
  getVirtualsByProductId,
  // getVirtual,
} from '../common/actions/virtuals';
import { getDefaultStop, getStopType } from '../common/routes';
import { getFilterStr } from '../common/global';
import { getCluesByProviderId } from '../common/actions/clues';
import { getItems, getItemsByProviderId } from '../common/actions/items';
import { getProductById } from '../common/actions/products';

import NotificationDialog from '../molecules/planners/NotificationDialog';
import styles from './PlannerPage.module.scss';
import ACNotesDialog from '../atoms/ACNotesDialog';
import ACLoader from '../atoms/ACLoader';
import SorterButtons from '../atoms/SorterButtons';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import config from '../../config/config';
import uuid from 'uuid';
import { formattedDietaries } from 'utils/commonFunction';


// An occasion has no route or virtual of its own — its components carry them — so
// the gameplay email's stop count is aggregated across the embedded component
// bookings. Child route/virtual stops are already hydrated by the API.
function getNotificationStops(data) {
  if (data?.isOccasion) {
    return (data.bookings || []).flatMap(
      (component) => component?.route?.stops || component?.virtual?.stops || []
    );
  }
  return data?.route?.stops || data?.virtual?.stops || [];
}

async function buildEmailBody(toEmailAddress, subject, templateType, data, booking) {
  let customContent = undefined;

  const TemplateTypeCodeMap = {
    'confirmation': 'AEX_CONF',
    'code': 'AEX_CODE'
  }

  console.log('emailBody :', { id: data.product?.id, p: data.product })
  if (data.product?.id) {
    const productId = data.product.id;
    let contentApiUrl = `${config.contentAPIUrl}/products/${productId}`;
    const req = { url: contentApiUrl, method: 'GET' };
    await acHTTPClient
      .request(req)
      .then((response) => {
        console.log('contentapi response : ', { response })
        let api_template_type_code = TemplateTypeCodeMap[templateType]
        const mail_template = response.data?.mail_templates?.find(mt => mt.template_type === api_template_type_code);
        if (mail_template?.is_enabled && mail_template?.published_content) {
          customContent = mail_template.published_content;
        }
        console.log('Got custom content ', { customContent })
      })
      .catch((error) => {
        console.error('contentapi error : ', { error })
      });
  }

  const templateCategory = booking.product && booking.product.category ? booking.product.category : 'external';

  const emailBody = {
    email: {
      from: {
        name: 'AmazingCo',
        address: 'hello@amazingco.me',
      },
      to: [
        {
          address: toEmailAddress,
        },
      ],
      bcc: [
        {
          address: 'hello@amazingco.me',
        },
        {
          address: 'tech@amazingco.me',
        },
      ],
      subject,
      data,
    },
  };

  if (customContent) {
    emailBody.email.templateContent = customContent
  } else {
    const templateName = `aex-${templateType}-${templateCategory}`;
    emailBody.email.template = templateName;
  }

  return emailBody;
}

class PlannerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModifyingRoute: false,
      isModifyingBookingNote: false,
      isModifyingVirtual: false,
      preview: undefined,
      html: undefined,
      booking: {},
      bookings: [],
      bookingsCountAll: 0,
      route: {},
      routes: [],
      notificationData: {},
      notificationText: '',
      users: [],
      sortByValue: 'default',
      openAlertDialog: false,
      errors: [],
      storyboards: [],
      items: [],
      clues: [],
      isModifyingStop: false,
      virtuals: [],
      virtual: {},
      isModifyingStopSpark: false,
      sparks: [],
      challenges: [],
      showLoader: false,
      occasion: {}
    };

    this.onSelectBooking = this.onSelectBooking.bind(this);
    this.onSelectRoute = this.onSelectRoute.bind(this);
    this.onOpenRightModal = this.onOpenRightModal.bind(this);
    this.onCloseRightModal = this.onCloseRightModal.bind(this);
    this.onOpenMainModal = this.onOpenMainModal.bind(this);
    this.onCloseMainModal = this.onCloseMainModal.bind(this);

    this.onPreviewConfirmation = this.onPreviewConfirmation.bind(this);
    this.onSendConfirmation = this.onSendConfirmation.bind(this);
    this.onPreviewCode = this.onPreviewCode.bind(this);
    this.onSendCode = this.onSendCode.bind(this);
    this.onClickAddNewRoute = this.onClickAddNewRoute.bind(this);

    this.onUpdateNotificationText = this.onUpdateNotificationText.bind(this);
    this.onUpdateBookingItemPayment = this.onUpdateBookingItemPayment.bind(this);
    this.onUpdateBookingItemActivity = this.onUpdateBookingItemActivity.bind(this);
    this.onUpdateStopBookingNote = this.onUpdateStopBookingNote.bind(this);
    this.onUpdateBookingManager = this.onUpdateBookingManager.bind(this);
    this.onDeleteBookingManager = this.onDeleteBookingManager.bind(this);
    this.onUpdateBookingDeliveryStatus = this.onUpdateBookingDeliveryStatus.bind(this);
    this.onUpdateBookingItemPrice = this.onUpdateBookingItemPrice.bind(this);
    this.onChooseComponentProviderItem = this.onChooseComponentProviderItem.bind(this);

    this.onClickClearBookingRoute = this.onClickClearBookingRoute.bind(this);
    this.onClickClearVirtualExp = this.onClickClearVirtualExp.bind(this);

    this.renderAddBookingStop = this.renderAddBookingStop.bind(this);
    this.renderAddBookingStopSpark = this.renderAddBookingStopSpark.bind(this);

    this.onSelectStopType = this.onSelectStopType.bind(this);
    this.onUpdateStopType = this.onUpdateStopType.bind(this);

    this.onSwapStops = this.onSwapStops.bind(this);
    this.onUpdateStoryboard = this.onUpdateStoryboard.bind(this);
    this.isPersonalisationDoneFunc = this.isPersonalisationDoneFunc.bind(this);

    this.onSelectOccasion = this.onSelectOccasion.bind(this);
  }

  componentDidMount() {
    this.props.getUsersFunc();
    this.props.getSparksFunc();
  }

  //FIXME: Deprecated lifecycle method
  componentWillReceiveProps(nextProps) {
    if (nextProps.searchContent) {
      this.setState({
        searchContent: nextProps.searchContent,
      });
    }
    if (nextProps.bookings && nextProps.bookings !== this.props.bookings) {
      const { bookings } = cloneDeep(nextProps);
      const { booking = { id: '' } } = cloneDeep(this.state);
      const findUpdatedBooking = filter(bookings, (b) => {
        return b.id === booking.id;
      });
      if (!isEmpty(findUpdatedBooking)) {
        // Internal update so that the selected booking is up-to-date after data manipulation
        // Our options are either make an API call or just find the relavent booking and set it in the state.
        this.setState({
          booking: cloneDeep(findUpdatedBooking[0]),
        });
      }
      // Internal update
      this.setState({
        bookings,
      });
    }
    if (nextProps.sparks && this.state.sparks !== nextProps.sparks) {
      this.setState({
        sparks: nextProps.sparks,
      });
    }
    if (nextProps.challenges && this.state.challenges !== nextProps.challenges) {
      this.setState({
        challenges: nextProps.challenges,
      });
    }
    if (nextProps.bookingsCountAll) {
      this.setState({ bookingsCountAll: nextProps.bookingsCountAll });
    }
    else {
      this.setState({ bookingsCountAll: 0 });
    }
    if (nextProps.notificationData) {
      this.setState({ notificationData: nextProps.notificationData });
    }
    if (nextProps.routes) {
      // Internal update
      this.setState({
        routes: nextProps.routes,
      });
    } else {
      // Internal update
      this.setState({
        routes: [],
      });
    }
    if (nextProps.route) {
      // Internal update
      this.setState({
        route: nextProps.route,
      });
    }
    if (nextProps.isCodeSent) {
      let booking = cloneDeep(this.state.booking);
      let code = {
        type: 'email',
        // FIXME: Use this until we have a proper user management in place
        userGivenName: this.props.authProperties.loggedInUser.givenName,
      };
      // External update
      // FIXME: Move the below chunk of code to a better place:
      if (nextProps.isBookingNotifyCodeSent === false) {
        this.props.postBookingNotificationFunc(booking.id, 'codes', code);
      }
    }
    if (nextProps.html) {
      this.setState({ html: nextProps.html });
    }
    // This is to clear the component upon filtering. Otherwise if no data comes from the api, the bookings component retains its state and projects that the filter isn't working.
    if (nextProps.filter && nextProps.filter !== this.props.filter)
      this.setState({
        bookings: [],
      });
    if ((nextProps.filter && nextProps.filter !== this.props.filter) || nextProps.refreshBookings) {
      const { hqId } = this.props;
      let filterStr = '';
      // Check if there is specific booking number the user wants to go to. The use case is usually coming from PSP.
      // If it is empty, load all. Otherwise, load what has been requested.
      if (!hqId || isEmpty(hqId)) {
        let { filter = {} } = nextProps;

        if (filter.hqId) {
          // If it is hqId in the filter object, ignore all other filter and just grab result for the booking number
          const { hqId } = filter;
          filter = { hqId };
        }
        filterStr = getFilterStr(filter);
      } else {
        let filter = { hqId };

        filterStr = getFilterStr(filter);
      }
      this.props.getBookingsFunc(filterStr);
      this.props.getItemsFunc();
    }
    if (nextProps.users && nextProps.users !== this.props.users) {
      this.setState({ users: nextProps.users });
    }
    if (nextProps.items && nextProps.items !== this.props.items) {
      this.setState({ items: nextProps.items });
    }

    if (nextProps.notActiveItems && nextProps.notActiveItems !== this.props.notActiveItems) {
      this.setState({ notActiveItems: nextProps.notActiveItems })
    }

    if (nextProps.clues && nextProps.clues !== this.props.clues) {
      this.setState({ clues: nextProps.clues });
    }
    if (nextProps.storyBoards && nextProps.storyBoards !== this.props.storyBoards) {
      this.setState({
        storyBoards: nextProps.storyBoards,
      });
    }
    if (nextProps.virtuals && nextProps.virtuals !== this.props.virtuals) {
      this.setState({ virtuals: nextProps.virtuals });
    }
    if (nextProps.virtual && nextProps.virtual !== this.props.virtual) {
      this.setState({ virtual: nextProps.virtual });
    }
    if (nextProps.product && nextProps.product !== this.props.product) {
      const { preview } = this.state;
      this.setState({ product: nextProps.product }, () => this.onRefreshDialog(preview));
    }
  }

  getTemplateForNotification(productId) {
    const experienceTemplates = [
      { productId: 'adn-0b5a03ca', templateName: 'at-home-date-night' },
      { productId: 'apd-68182fe1', templateName: 'at-home-pamper-date' },
      { productId: 'fdn-c9a03955', templateName: 'at-home-foodie-date-night' },
      { productId: 'ss-yv-6136b34c', templateName: 'at-home-sofa-sommelier-yarra-valley' },
      {
        productId: 'ss-bv-0d41847a',
        templateName: 'at-home-sofa-sommelier-barossa',
      },
    ];
    const experienceTemplate = experienceTemplates.find((t) => {
      return t.productId === productId;
    }) || { templateName: '' };

    return experienceTemplate;
  }

  onClickAddNewRoute() {
    this.props.onSelectACDrawerMenuItemFunc('routes');
  }

  onUpdateBookingItemPayment(stopIndex, payment) {
    let { booking } = cloneDeep(this.state);

    let stop = booking.route.stops[stopIndex];

    if (stop.item) {
      const { item } = stop;
      item.payment = payment;
      booking.route.stops[stopIndex] = stop;
      this.props.postBookingItemPaymentFunc(booking.id, item.id, payment, booking.occasionBookingId);
    }
  }

  onUpdateBookingItemActivity(stopIndex, activity, note) {
    let { booking } = cloneDeep(this.state);

    let stop = booking.route.stops[stopIndex];
    if (stop.item) {
      const { item } = stop;
      item.activity = activity;
      booking.route.stops[stopIndex] = stop;
      this.props.postBookingItemActivityFunc(booking.id, item.id, stopIndex, activity, note, booking.occasionBookingId);

    }
  }

  // occasionBookingId is what makes a component booking addressable — it is embedded in
  // its occasion and has no _id of its own. Undefined for a root booking.
  onUpdateBookingManager(bookingId, userId, occasionBookingId) {
    this.props.putBookingManagerFunc(bookingId, userId, occasionBookingId);
  }

  onDeleteBookingManager(bookingId, occasionBookingId) {
    this.props.deleteBookingManagerFunc(bookingId, occasionBookingId);
  }

  onUpdateBookingDeliveryStatus(bookingId, deliveryStatus) {
    this.props.putBookingDeliveryStatusFunc(bookingId, deliveryStatus);
  }

  // TEST AFFORDANCE: see postBookingMarkAvailable.
  onMarkBookingReady = (bookingId) => {
    return this.props.postBookingMarkAvailableFunc(bookingId);
  };


  onUpdateBookingItemPrice(itemId, price, tax) {
    const { booking } = cloneDeep(this.state);

    this.props.putBookingItemPriceFunc(
      booking.id,
      itemId,
      price,
      tax,
      booking.occasionBookingId
    );
  }

  /**
   * Records which of a component's allowed provider items delivers this booking.
   *
   * aex fills the stop's provider, item and price from the one chosen, so this sends only the
   * item id - the cost is not typed here and the ticket requirement follows the item.
   */
  onChooseComponentProviderItem(itemId) {
    const { booking } = cloneDeep(this.state);

    this.props.patchComponentStopProviderItemFunc(booking.id, itemId, booking.occasionBookingId);
  }

  onUpdateStopBookingNote(stopNumber, data) {
    let { booking } = cloneDeep(this.state);

    this.props.patchStopBookingNoteFunc(booking.id, stopNumber, data);
  }

  onClickClearBookingRoute() {
    let booking = cloneDeep(this.state.booking);

    booking.routeId = null;
    booking.route = {};
    booking.deliveryStatus = 'IN_PROGRESS';
    this.props.deleteOneBookingRouteFunc(booking.id, booking.occasionBookingId);
    // Internal update
    this.setState({
      isModifyingRoute: false,
      booking,
    });
  }

  onClickClearVirtualExp() {
    let booking = cloneDeep(this.state.booking);

    booking.virtualId = null;
    booking.virtual = {};
    this.props.deleteOneBookingVirtualFunc(booking.id, booking.occasionBookingId);
    // Internal update
    this.setState({
      isModifyingVirtual: false,
      booking,
    });
  }

  onPreviewConfirmation(booking) {
    this.props.getBookingNotificationDataFunc(booking.id, booking.occasionBookingId).then(({ type, notificatioNDataResponse }) => {
      this.setState({ booking }, () => {
        this.populatePreviewConfirmation(booking)
      });
    })
  }

  async populatePreviewConfirmation(booking) {
    const { notificationData: data, notificationText } = this.state;
    if (isEmpty(data)) return <div />;
    const { experiencePersonalisationDetails } = data;
    if (!isEmpty(notificationText)) {
      if (!data.notficiation) data.notification = {};
      data.notification.text = notificationText;
    }
    if(!isEmpty(experiencePersonalisationDetails)) {
      const attendeeInformationResponse = experiencePersonalisationDetails?.userResponse?.sections?.[0]?.questions?.find(question => question?.configurationData?.questionCode === "attendee_information");
      const result = formattedDietaries(attendeeInformationResponse);
      if(result?.length > 0) {
        data.attendeeDietaries = result?.join(' • ');
      }
    }

    const subject = `AmazingCo Booking Confirmation [${booking.hqId}]`;
    const toEmailAddress = 'tech@amazingco.me';
    const emailBody = await buildEmailBody(toEmailAddress, subject, 'confirmation', data, booking)
    this.props.postPreviewConfirmationFunc(emailBody);
    this.onOpenMainModal('confirmation');
  }

  async onSendConfirmation() {
    const { booking, notificationData: data, notificationText } = this.state;
    if (isEmpty(data)) return <div />;
    const { experiencePersonalisationDetails } = data;
    if (!isEmpty(notificationText)) {
      if (!data.notficiation) data.notification = {};
      data.notification.text = notificationText;
    }

    let toEmailAddress;
    if (data.hq) {
      // toEmailAddress
      if (data.hq.customer && data.hq.customer.email && data.hq.customer.email.address) {
        toEmailAddress = data.hq.customer.email.address;
      }
    }

    if (!toEmailAddress) {
      alert('This booking does not appear to have a valid email address attached to it.  Please check the customer details in HQ or UHQ')
      return;
    }

    if(!isEmpty(experiencePersonalisationDetails)) {
      const attendeeInformationResponse = experiencePersonalisationDetails?.userResponse?.sections?.[0]?.questions?.find(question => question?.configurationData?.questionCode === "attendee_information");
      const result = formattedDietaries(attendeeInformationResponse);
      if(result?.length > 0) {
        data.attendeeDietaries = result?.join(' • ');
      }
    }

    const subject = `AmazingCo Booking Confirmation [${booking.hqId}]`;

    const emailBody = await buildEmailBody(toEmailAddress, subject, 'confirmation', data, booking);
    const actorData = {
      type: 'email',
      userGivenName: this.props.authProperties.loggedInUser.givenName,
      status: "Created",
      id: uuid.v4()
    };
    this.props.postSendConfirmationFunc(emailBody,actorData,booking.id);
    this.onCloseMainModal();
  }


  onPreviewCode(booking) {
    this.props.getBookingNotificationDataFunc(booking.id, booking.occasionBookingId).then(({ type, notificatioNDataResponse }) => {
      this.setState({ booking }, () => {
        this.populatePreviewCode(booking)
      });
    })
  }

  async populatePreviewCode(booking) {
    const { notificationData: data, notificationText } = this.state;
    const category = data.product && data.product.category ? data.product.category : 'external';
    if (isEmpty(data)) return <div />;
    if (!isEmpty(notificationText)) {
      if (!data.notficiation) data.notification = {};
      data.notification.text = notificationText;
    }

    const stops = getNotificationStops(data);
    const { config } = this.props;
    const { eeeURL = '' } = config;

    if (!data) return <div />;

    data.link = `${eeeURL}/?bookingId=${data.id}`;
    data.totalStops = stops.length;
    if (category === 'external') {
      data.totalStops = stops.filter(stop => stop.type !== 'spark-stop').length;
    }

    const subject = 'Your AmazingCo experience is ready!';
    const toEmailAddress = 'tech@amazingco.me';
    const emailBody = await buildEmailBody(toEmailAddress, subject, 'code', data, booking);

    this.props.postPreviewConfirmationFunc(emailBody);
    this.onOpenMainModal('code');
  }

  async onSendCode() {
    const { booking, notificationData: data, notificationText } = this.state;
    const category = data.product && data.product.category ? data.product.category : 'external';
    if (isEmpty(data)) return <div />;
    if (!isEmpty(notificationText)) {
      if (!data.notficiation) data.notification = {};
      data.notification.text = notificationText;
    }

    const stops = getNotificationStops(data);

    if (!data) return <div />;

    let toEmailAddress;

    if (data.hq) {
      if (data.hq.customer && data.hq.customer.email && data.hq.customer.email.address) {
        toEmailAddress = data.hq.customer.email.address;
      }
    }

    if (!toEmailAddress) {
      alert('This booking does not appear to have a valid email address attached to it.  Please check the customer details in HQ or UHQ')
      return;
    }

    data.link = `https://eee.amazingco.me/?bookingId=${data.id}`;
    data.totalStops = stops.length;
    if (category === 'external')
      data.totalStops = stops.filter(stop => stop.type !== 'spark-stop').length;

    const subject = 'Your AmazingCo experience is ready!';
    const emailBody = await buildEmailBody(toEmailAddress, subject, 'code', data, booking);

    const actorData = {
      type: 'email',
      userGivenName: this.props.authProperties.loggedInUser.givenName,
      status: 'CREATED',
      id: uuid.v4()
    };

    this.props.postSendCodeFunc(emailBody, data, actorData);
    this.onCloseMainModal();
  }

  onSelectBooking(booking) {
    if (this.state.booking.id !== booking.id) {

      if (booking.productId) this.props.getRoutesByProductIdFunc(booking.productId);
      if (booking.productId) this.props.getVirtualsByProductIdFunc(booking.productId);

      this.props.getBookingNotificationDataFunc(booking.id, booking.occasionBookingId);

      // Internal update

      this.setState({
        booking,
      });
    }
    // // Update notification data object. Otherwise, notificationData object has missing route notes and it requires to refresh the whole application in order to make it work.
    // else this.props.getBookingNotificationDataFunc(booking.id);
  }

  onSelectOccasion(occasion) {
    if (this.state.occasion.id !== occasion.id) {

    }

  }

  onSelectRoute(route) {
    let booking = cloneDeep(this.state.booking);

    booking.routeId = route.id;
    booking.route = cloneDeep(route);
    booking.deliveryStatus = 'IN_PROGRESS';
    booking = _.set(booking, 'notification.lastCodeSent.isValid', false);
    booking = _.set(booking, 'notification.lastCodeSent.dateTime', moment().toISOString());

    // External update
    // TODO
    console.log(booking,"booking")
    this.props.patchBookingFunc(booking);

    // Internal update
    this.setState({
      isModifyingRoute: false,
      booking,
    });
  }

  onSelectVirtual = (virtual) => {
    let { booking = {} } = cloneDeep(this.state);

    booking.virtualId = virtual.id;
    booking.virtual = cloneDeep(virtual);
    if (!virtual.userId) {
      booking.userId = virtual.userId;
    }
    // External update
    // TODO
    this.props.patchBookingFunc(booking);

    // Internal update
    this.setState({
      isModifyingVirtual: false,
      booking,
    });

    console.log('booking-experience', booking);
  };

  onOpenRightModal() {
    // Populate latest routes
    if (this.state.booking && this.state.booking.productId)
      this.props.getRoutesByProductIdFunc(this.state.booking.productId);
    this.setState({ isModifyingRoute: true });
  }

  onCloseRightModal = () => {
    this.setState({ isModifyingRoute: false });
  };

  onOpenVirtualModal = () => {
    // Populate latest virtuals
    if (this.state.booking && this.state.booking.productId)
      this.props.getVirtualsByProductIdFunc(this.state.booking.productId);
    this.setState({ isModifyingVirtual: true });
  };

  onCloseVirtualModal = () => {
    this.setState({ isModifyingVirtual: false });
  };

  onOpenMainModal(notificationType) {
    this.setState({ preview: notificationType });
  }

  onCloseMainModal = () => {
    this.setState({ preview: null, notificationText: '' });
  };

  onOpenStopModal = () => {
    this.setState({ isModifyingStop: true, stop: getDefaultStop() });
  };

  onOpenStopSparkModal = () => {
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getChallengesBySparkIdFunc('-1');
    getCluesBySparkIdFunc('-1');
    this.setState({ isModifyingStopSpark: true, stop: getDefaultStop() });
  };

  onCloseStopModal = () => {
    this.setState({ isModifyingStop: false, stop: getDefaultStop(), items: [], clues: [] });
  };

  onCloseStopSparkModal = () => {
    this.setState({ isModifyingStopSpark: false, stop: getDefaultStop(), items: [], clues: [] });
  };

  onSelectSparkItem = (name, selectedOption) => {
    const { object = {} } = selectedOption;
    if (name === 'spark') this.onSelectSpark(object);
    if (name === 'challenge') this.onSelectSparkChallenge(object);
  };

  onClickAlertDialogClose = () => {
    this.setState({
      openAlertDialog: false,
    });
  };

  onUpdateNotificationText = (notificationText) => {
    this.setState({ notificationText });
  };

  onRefreshDialog = (preview) => {
    const { booking = {} } = cloneDeep(this.state);
    switch (preview) {
      case 'confirmation':
        this.populatePreviewConfirmation(booking);
        break;
      case 'code':
        this.populatePreviewCode(booking);
        break;
      default:
        return null;
    }
  };

  getCriteriaToShowRelaventRoute(attendeesCount) {
    // Maintain a list of criteria to be checked for relavent routes
    let checkCriteria = {
      paxSize: false,
    };

    if (attendeesCount > 0) {
      checkCriteria.paxSize = true;
    }

    return checkCriteria;
  }

  onSelectProvider = (provider) => {
    // Internal update
    const { stop = {} } = cloneDeep(this.state);
    stop.provider = provider;
    stop.item = {};
    stop.clue = {};
    this.setState({
      stop: stop,
    });

    // External update
    if (provider) this.props.getItemsByProviderIdFunc(provider.id);
    if (provider) this.props.getCluesByProviderIdFunc(provider.id);
    if (provider) this.props.getStoryboards(provider.id);
  };


  onSelectItem = (item) => {
    // Internal update
    const stop = this.state.stop;
    stop.item = item;
    this.setState({
      stop: stop,
    });
  };

  onSelectClue = (clue) => {
    // Internal update
    const stop = this.state.stop;
    stop.clue = clue;
    this.setState({
      stop: stop,
    });
  };

  onSelectSpark = (spark) => {
    const stop = this.state.stop;
    stop.type = 'spark-stop'
    stop.spark = spark;
    stop.challenge = '';
    stop.clue = '';
    this.setState({ stop });

    const { id = '' } = spark;
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getChallengesBySparkIdFunc(id);
    getCluesBySparkIdFunc(id);
  };

  onSelectSparkChallenge = (challenge) => {
    const stop = this.state.stop;
    stop.challenge = challenge;
    this.setState({ stop });
  };

  onSelectSparkClue = (clue) => {
    const stop = this.state.stop;
    stop.clue = clue;
    this.setState({ stop });
  };

  onChangeSparkStopFunc = (name, value) => {
    if (name === 'action') {
      this.onUpdateStopAction(value)
    }
  }

  onInputChangeSpark = (query) => {
    const { getSparksFunc } = this.props;
    const filterStr = `&query=${query}`;

    getSparksFunc(filterStr);
  };

  onUpdateStopAction = (value) => {
    // Internal update
    const { stop = {} } = cloneDeep(this.state);
    stop.action = value;
    this.setState({
      stop: stop,
    });
  };

  onUpdateStopVariables = (variables) => {
    // Internal update
    let { stop = {} } = cloneDeep(this.state);
    stop.variables = variables;
    this.setState({
      stop: stop,
    });
  };

  onSelectStop = (stop) => {
    if (stop.provider) {
      // Internal update
      this.setState({
        stop,
        isModifyingStop: true,
      });
      // External update
      if (stop.provider.id !== undefined) {
        this.props.getItemsByProviderIdFunc(stop.provider.id);
        this.props.getCluesByProviderIdFunc(stop.provider.id);
        this.props.getStoryboards(stop.provider.id);
      } else {
        // Force clearing items and clues from redux store objects by searching empty string.
        // Otherwise, redux keeps it in memory and this comes back upon next call.
        this.props.getItemsByProviderIdFunc('');
        this.props.getCluesByProviderIdFunc('');
        this.props.getStoryboards('');
      }
    }
    else {
      //For case of spark stops under bookings having route
      if (this.state.booking.routeId !== undefined) {
        this.setState({
          stop,
          isModifyingStopSpark: true,
        });
        if (stop.sparkId !== undefined) {
          this.props.getChallengesBySparkIdFunc(stop.sparkId);
          this.props.getCluesBySparkIdFunc(stop.sparkId);
        }
        else {
          this.props.getChallengesBySparkIdFunc('-1');
          this.props.getCluesBySparkIdFunc('-1');
        }
      }
    }
  };

  onUpdateStoryboard(storyboard) {
    // Internal update
    let { stop = {} } = cloneDeep(this.state);
    stop.storyboard = storyboard;

    this.setState({
      stop: stop,
    });
  }


  onSelectStopType(type) {
    // Internal update
    let { stop = {} } = cloneDeep(this.state);
    stop.type = type;
    this.setState({
      stop: stop,
    });
  }

  // FIXME: Create Generic Method to update stop
  onUpdateStopType(type) {
    // Internal update
    let { stop = {} } = cloneDeep(this.state);
    stop.type = type;

    this.setState({
      stop: stop,
    });
  }

  hasStopErrors(stop) {
    let isError = true;
    if (stop) {
      isError = false;
      let errors = [];
      if (!stop.type) {
        isError = true;
        errors.push('Please select a stop type');
      }
      if (stop.provider) {
        if (!stop.provider.id) {
          isError = true;
          errors.push('Please select a provider');
        }
        const seleectedProviderData = stop.provider;
        const storyboardEnabled = seleectedProviderData?.enablingStoryboard || false;
        if (storyboardEnabled && isEmpty(stop.storyboard)) {
          isError = true;
          errors.push('Please select a Storyboard');
        }
      }
      if (stop.clue) {
        if (!stop.clue.id && stop.type !== 'payment-only') {
          isError = true;
          errors.push('Please select a clue');
        }
      }
      this.setState({
        errors,
      });
    }
    return isError;
  }

  hasStopSparkErrors(stop) {
    const { type = '' } = stop;
    let isError = true;
    if (stop) {
      isError = false;
      let errors = [];

      if (type === getStopType().SPARK_STOP) {
        const { spark, challenge } = stop;
        if (isEmpty(spark)) {
          isError = true;
          errors.push('Please select a connection spark');
        }
        if (isEmpty(challenge)) {
          isError = true;
          errors.push('Please select a challenge');
        }
      } else {
        if (stop.provider) {
          if (!stop.provider.id) {
            isError = true;
            errors.push('Please select a provider');
          }
        }
        if (type !== getStopType().INSTA_STOP && isEmpty(stop.item)) {
          isError = true;
          errors.push('Please select an item');
        }
        if (stop.clue) {
          if (!stop.clue.id) {
            isError = true;
            errors.push('Please select a clue');
          }
        }
      }
      if (!stop.type) {
        isError = true;
        errors.push('Please select a stop type');
      }

      this.setState({
        errors,
      });
    }
    return isError;
  }

  onSaveStop = () => {
    const { stop = {}, booking = {} } = cloneDeep(this.state);
    if (
      stop.type !== 'payment-only' &&
      stop.clue &&
      stop.clue.id &&
      stop.clue.id === 'payment-only-placeholder-clue'
    ) {
      stop.clue = {};
    }

    if (this.hasStopErrors(stop)) {
      this.setState({
        openAlertDialog: true,
      });
      return false;
    }

    const newStop = this.getStopForAPI(stop);
    const { index = -1 } = stop;

    const { notification } = booking;
    const areCodesSent = !notification.lastCodeSent || notification.lastCodeSent?.isValid;
    const isPublishable = areCodesSent;
    
    if(isPublishable){
      this.props.patchBookingPublishableFunc(booking, isPublishable);

      this.setState({ showLoader: true });
      // Time out added to avoid clash of events
      setTimeout(() => {
        this.setState({ showLoader: false });
        // External update
        if (index >= 0) {
          this.props.putBookingStopFunc(booking.id, newStop, index);
        } else {
          this.props.putBookingStopFunc(booking.id, newStop, -1);
        }
    
        this.setState({
          stop: getDefaultStop(),
        });
  
      }, 500);
    } else{
      this.setState({ showLoader: false });
        // External update
        if (index >= 0) {
          this.props.putBookingStopFunc(booking.id, newStop, index);
        } else {
          this.props.putBookingStopFunc(booking.id, newStop, -1);
        }
    
        this.setState({
          stop: getDefaultStop(),
        });
    }

    return true;

  };

  onDeleteStopProvider = (providerId) => {
    if (this.onDeleteProviderStop(providerId)) {
      const { booking = {} } = cloneDeep(this.state);
      const { notification } = booking;
      const areCodesSent = !notification.lastCodeSent || notification.lastCodeSent?.isValid;
      const isPublishable = areCodesSent;
      if(isPublishable){
        this.props.patchBookingPublishableFunc(booking, isPublishable);
      }
      this.onCloseStopModal();
    }
  }

  onDeleteProviderStop = (providerId) => {

    const { booking = {} } = cloneDeep(this.state);

    this.props.deleteOneBookingStopProviderFunc(booking.id, providerId, "");

    this.setState({
      stop: getDefaultStop(),
    });

    return true;
  };

  onDeleteStopSpark = (sparkId) => {
    if (this.onDeleteSparkStop(sparkId)) {
      const { booking = {} } = cloneDeep(this.state);
      const { notification } = booking;
      const areCodesSent = !notification.lastCodeSent || notification.lastCodeSent?.isValid;
      const isPublishable = areCodesSent;
      if(isPublishable){
        this.props.patchBookingPublishableFunc(booking, isPublishable);
      }
      this.onCloseStopSparkModal();
    }
  }

  onDeleteSparkStop = (sparkId) => {

    const { booking = {} } = cloneDeep(this.state);

    this.props.deleteOneBookingStopSparkFunc(booking.id, sparkId);

    this.setState({
      stop: getDefaultStop(),
    });

    return true;
  };

  getStopForAPI(stop) {
    const newStop = {};

    if (stop.provider) newStop.providerId = stop.provider.id;
    if (stop.clue) newStop.clueId = stop.clue.id;
    if (stop.item) newStop.itemId = stop.item.id;
    if (stop.type) newStop.type = stop.type;
    if (stop.storyboard) {
      newStop.storyboard = { value: stop.storyboard.value, label: stop.storyboard.label };
      newStop.storyboardId = stop.storyboard.value;
    }
    newStop.action = stop.action;
    newStop.variables = stop.variables;

    return newStop;
  }

  onSaveStopHandler = () => {
    if (this.onSaveStop()) {
      this.onCloseStopModal();
    }
  }

  onSaveSparkStop = () => {
    if (this.onSaveStopSpark()) {
      this.onCloseStopSparkModal();
    }
  }

  onSaveStopSpark() {
    console.log('onSaveStopSpark')
    const { booking = {} } = cloneDeep(this.state);
    const stop = this.state.stop;

    if (this.hasStopSparkErrors(stop)) {
      this.setState({
        openAlertDialog: true,
      });
      return;
    }

    const newStops = this.getStopSparkForAPI(stop);
    console.log("file: PlannerPage.jsx:1128 ~ PlannerPage ~ onSaveStopSpark ~ newStops:", newStops)
    
    
    const { notification } = booking;
    const areCodesSent = !notification.lastCodeSent || notification.lastCodeSent?.isValid;
    const isPublishable = areCodesSent;

    const { index = -1 } = stop;

  if(isPublishable){
    this.props.patchBookingPublishableFunc(booking, isPublishable);
      this.setState({ showLoader: true });

      // Time out added to avoid clash of events
      setTimeout(() => {
        this.setState({ showLoader: false });
      // External update
      if (index >= 0) {
        this.props.putBookingStopFunc(booking.id, newStops, index);
      }
      else {
        this.props.putBookingStopFunc(booking.id, newStops, -1);
      }

      this.setState({
        stop: getDefaultStop(),
      });
    }, 500);
  } else {
    this.setState({ showLoader: false });
    // External update
    if (index >= 0) {
      this.props.putBookingStopFunc(booking.id, newStops, index);
    }
    else {
      this.props.putBookingStopFunc(booking.id, newStops, -1);
    }

    this.setState({
      stop: getDefaultStop(),
    });
  }

    return true;
  }

  getStopSparkForAPI(stop) {
    let newStop = {};

    if (stop.provider) newStop.providerId = stop.provider.id;
    if (stop.clue) newStop.clueId = stop.clue.id;
    if (stop.item) newStop.itemId = stop.item.id;
    if (stop.spark) newStop.sparkId = stop.spark.id;
    if (stop.challenge) newStop.challengeId = stop.challenge.id;
    newStop.action = stop.action;
    newStop.variables = stop.variables;
    newStop.type = stop.type;

    return newStop;
  }

  onSwapStops(stops,toUpdateBooking) {    
    let booking = cloneDeep(toUpdateBooking);
    booking.route.stops = cloneDeep(stops);
    const { notification } = booking;
    const areCodesSent = !notification.lastCodeSent || notification.lastCodeSent?.isValid;
    const isPublishable = areCodesSent;

    if(isPublishable){
      this.props.patchBookingPublishableFunc(booking, isPublishable, true);
      this.setState({ showLoader: true });
      // Time out added to avoid clash of events
      setTimeout(() => {
        this.setState({ showLoader: false });
        // External update
        // this.props.patchBookingStopsOrderFunc(booking);
      }, 500);
    } else {
      this.setState({ showLoader: false });
        // External update
        this.props.patchBookingStopsOrderFunc(booking);
    }
  }

  onClickAlertDialogClose() {
    this.setState({
      openAlertDialog: false,
    });
  }

  renderNotificationDialog(preview) {
    switch (preview) {
      case 'confirmation':
        return (
          <NotificationDialog
            isOpened={true}
            onCloseDialog={this.onCloseMainModal}
            onRefreshDialog={() => this.onRefreshDialog('confirmation')}
            html={this.state.html}
            onPressedSubmit={this.onSendConfirmation}
            onUpdateNotificationTextFunc={this.onUpdateNotificationText}
          />
        );
      case 'code':
        return (
          <NotificationDialog
            isOpened={true}
            onCloseDialog={this.onCloseMainModal}
            onRefreshDialog={() => this.onRefreshDialog('code')}
            html={this.state.html}
            onPressedSubmit={this.onSendCode}
            onUpdateNotificationTextFunc={this.onUpdateNotificationText}
          />
        );
      default:
        return null;
    }
  }

  renderSetRoute(routes, booking) {
    const { hq = {}, id = '' } = booking;
    let attendeesCount = 0;
    // FIXME: How hq can be empty?
    if (hq && !isEmpty(hq)) {
      attendeesCount = hq.attendeesCount || 0;
    }

    const relaventRouteCriteria = this.getCriteriaToShowRelaventRoute(attendeesCount);

    const { dateTime, dietaries } = hq;
    const bookingDayOfWeek = moment(dateTime).format('dddd');
    relaventRouteCriteria.bookingDay = bookingDayOfWeek;

    // Check if any of the dietaries requirements is true
    const dietariesRequirements = Object.values(dietaries).some((v) => v);
    relaventRouteCriteria.dietariesRequirements = dietariesRequirements ? dietaries : null;

    return (
      <SetRoute
        key={'SetRoute_' + id}
        routes={routes}
        relaventRouteCriteria={relaventRouteCriteria}
        attendeesCount={attendeesCount}
        isModifying={this.state.isModifyingRoute}
        onSelectRouteFunc={this.onSelectRoute}
        onCloseFunc={this.onCloseRightModal}
        onClickAddNewRoute={this.onClickAddNewRoute}
        onClickClearBookingRouteFunc={this.onClickClearBookingRoute}
      />
    );
  }

  renderSetVirtual(virtuals, booking) {
    const { id = '' } = booking;

    return (
      <SetVirtual
        key={'SetVirtual_' + id}
        virtuals={virtuals}
        isModifying={this.state.isModifyingVirtual}
        onSelectVirtualFunc={this.onSelectVirtual}
        onCloseFunc={this.onCloseVirtualModal}
        onClickAddNewVirtual={this.onClickAddNewVirtual}
        onClickClearVirtualExpFunc={this.onClickClearVirtualExp}
      />
    );
  }

  renderAddBookingStop() {
    const { items = [], clues = [], stop = {}, storyBoards = [] } = cloneDeep(this.state);
    return (
      <SetStop
        isModifying={this.state.isModifyingStop}
        onCloseFunc={this.onCloseStopModal}
        items={items}
        clues={clues}
        stop={stop}
        storyboards={storyBoards}
        onUpdateStoryBoardFunc={this.onUpdateStoryboard}
        onSelectProviderFunc={this.onSelectProvider}
        onSelectItemFunc={this.onSelectItem}
        onSelectClueFunc={this.onSelectClue}
        onUpdateStopActionFunc={this.onUpdateStopAction}
        onUpdateStopVariablesFunc={this.onUpdateStopVariables}
        onSaveStopFunc={this.onSaveStopHandler}
        onDeleteStopProviderFunc={this.onDeleteStopProvider}
        onSelectStopTypeFunc={this.onSelectStopType}
        onUpdateStopTypeFunc={this.onUpdateStopType}
        showErrorToastFunc={this.showErrorToast}
      />
    );
  }

  renderAddBookingStopSpark() {
    const { clues = [], stop = {} } = cloneDeep(this.state);
    return (
      <SetSparkStop
        stop={stop}
        sparks={this.state.sparks}
        challenges={this.state.challenges}
        clues={clues}
        isModalOpen={this.state.isModifyingStopSpark}
        onCloseFunc={this.onCloseStopSparkModal}
        onSelectFunc={this.onSelectSparkItem}
        onSelectClueFunc={this.onSelectSparkClue}
        onChangeStopFunc={this.onChangeSparkStopFunc}
        onSaveStopFunc={this.onSaveSparkStop}
        onDeleteStopSparkFunc={this.onDeleteStopSpark}
        onInputChangeSparkFunc={this.onInputChangeSpark}
      />

    );
  }
  /**
   * Send request to the back-end
   */
  onUpdateBookingNote = ({ notes, dateTime }) => {
    const { patchBookingNote } = this.props;
    const { booking } = this.state;

    patchBookingNote(booking.id, notes, dateTime); // FIXME: Result Handler?
    this.onToggleButtonNoteDialog();
  };

  onClickBookingNote = (event, booking) => {
    this.setState({
      booking,
    }, () => {
      this.onToggleButtonNoteDialog();
    });


  };

  publishChangesForBooking = () => {
    const { booking } = this.state;
    this.props.patchBookingPublishedFunc(booking, true);
  }

  isPersonalisationDoneFunc=(isPersonalised)=>{
    const {booking} = cloneDeep(this.state);
    this.props.putBookingIsPersonalisedFunc(booking.id, isPersonalised);
  }

  /**
   * Toggles the visibility of the booking-level notes dialog
   */
  onToggleButtonNoteDialog = (event) => {
    const { isModifyingBookingNote } = this.state;
    this.setState({ isModifyingBookingNote: !isModifyingBookingNote });
  };

  /**
   * Handles the sort by button change
   */
  onSortByChanged = (sortByValue) => {
    const { onSortByDateFunc } = this.props;
    this.setState({ sortByValue }, () => {
      onSortByDateFunc(sortByValue);
    });
  };

  showErrorToast = (message, errorObj) => {
    toast((
      <div>
        <div style={{ color: '#f00', cursor: 'default' }}><b>Planner Error</b></div>
        <div style={{ cursor: 'default' }}>
          <p>{message}</p>
          <p style={{ fontSize: 'small' }}>Action required - Please copy the text in the box below, and post it in Slack on #tech_support to help us diagnose this issue further.</p>
        </div>

        <pre style={{
          maxWidth: '100%',
          width: '100%',
          maxHeight: '800px',
          height: '100%',
          fontSize: 'small',
          fontFamily: 'courier',
          overflowX: 'scroll',
          whiteSpace: 'pre-wrap',
          border: '1px solid #ccc',
          cursor: 'text',
          padding: '8px'
        }}>AEX-HQ Booking Notification Error Report

          ```
          {JSON.stringify({
            dateTime: new Date().toISOString(),
            error: errorObj || 'Unknown Error',
            message: errorObj?.message || message,
          }, undefined, 2)}
          ```
        </pre>
      </div>), {
      autoClose: false,
      closeOnClick: false,
      draggable: false
    });
  }
  /**
   * Render the pagination area
   */
  renderPagination() {
    const { onFilterByPageNumberFunc, filter } = this.props;
    const { bookingsCountAll } = this.state;
    const { pageNumber = 1 } = filter;
    return (
      <div
        style={{
          background: '#fff',
          borderTop: '1px solid rgb(224, 224, 224)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '16px'
        }}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}>
          <Pagination
            onChange={onFilterByPageNumberFunc}
            current={pageNumber}
            pageSize={config.limit.bookings}
            total={bookingsCountAll}
            style={{ margin: '1em' }}
            locale={{
              // Options.jsx
              items_per_page: '/ page',
              jump_to: 'Go to',
              jump_to_confirm: 'confirm',

              // Pagination.jsx
              prev_page: 'Previous Page',
              next_page: 'Next Page',
              prev_5: 'Previous 5 Pages',
              next_5: 'Next 5 Pages',
              prev_3: 'Previous 3 Pages',
              next_3: 'Next 3 Pages',
            }}
          />
        </div>
        <div style={{
          display: 'flex',
          fontSize: '14px'
        }}><span>Total:</span> <span>{bookingsCountAll}</span></div>

      </div>
    );
  }

  renderAlertDialog(errors) {
    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Alert
          </DialogTitle>
          <DialogContent>
            {errors.map((e) => {
              return <DialogContentText>{e}</DialogContentText>;
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  render() {

    const {
      bookings,
      booking,
      isModifyingBookingNote,
      preview,
      routes,
      virtuals,
      users,
      sortByValue,
      notActiveItems,
      errors = [],
    } = this.state;

    const { note = {} } = booking;

    const { fetching, config } = this.props;
    const { showLoader } = this.state;
    const { googleMapURL = '' } = config;
    return (
      <ACLoader active={fetching || showLoader}>
        <div className={styles.root}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '8px 16px' }}>
            <div>
              <SorterButtons sortByValue={sortByValue} onChange={this.onSortByChanged} />
            </div>
          </div>
          <Bookings
            config={config}
            bookings={bookings}
            packageOwners={users}
            booking={booking}
            users={users}
            notActiveItems={notActiveItems}
            onSelectBookingFunc={this.onSelectBooking}
            onClickSetRouteFunc={this.onOpenRightModal}
            onClickSetVirtualFunc={this.onOpenVirtualModal}
            onPreviewConfirmationFunc={this.onPreviewConfirmation}
            onPreviewCodeFunc={this.onPreviewCode}
            onUpdateBookingItemPaymentFunc={this.onUpdateBookingItemPayment}
            onUpdateBookingItemActivityFunc={this.onUpdateBookingItemActivity}
            onUpdateStopBookingNoteFunc={this.onUpdateStopBookingNote}
            onUpdateBookingManagerFunc={this.onUpdateBookingManager}
            onDeleteBookingManagerFunc={this.onDeleteBookingManager}
            onUpdateBookingDeliveryStatusFunc={this.onUpdateBookingDeliveryStatus}
            onMarkBookingReadyFunc={this.onMarkBookingReady}
            onUpdateBookingItemPriceFunc={this.onUpdateBookingItemPrice}
            onChooseComponentProviderItemFunc={this.onChooseComponentProviderItem}
            onClickBookingNote={this.onClickBookingNote}
            onClickAddBookingStopFunc={this.onOpenStopModal}
            onClickAddBookingStopSparkFunc={this.onOpenStopSparkModal}
            onSelectStopFunc={this.onSelectStop}
            googleMapURL={googleMapURL}
            getProductByIdFunc={this.props.getProductByIdFunc}
            onSwapStopsFunc={this.onSwapStops}
            onPublishBookingFunc={this.publishChangesForBooking}
            onUpdatePersonalisationCheckFunc={this.isPersonalisationDoneFunc}
          />
          {this.renderPagination()}
          {booking && !isEmpty(booking) ? this.renderSetRoute(routes, booking) : null}
          {booking && !isEmpty(booking) ? this.renderSetVirtual(virtuals, booking) : null}
          {booking && !isEmpty(booking) ? this.renderAddBookingStop() : null}
          {booking && !isEmpty(booking) ? this.renderAddBookingStopSpark() : null}
          {this.renderNotificationDialog(preview)}
          <ACNotesDialog
            title="Booking Note"
            open={isModifyingBookingNote}
            onClickCancelFunc={this.onToggleButtonNoteDialog}
            onClickUpdateFunc={this.onUpdateBookingNote}
            isMultiline={true}
            notes={note.private || ''}
            dateTime={note.dateTime || null}
            areNotesCompulsory={false}
            withDate
          />
          {this.renderAlertDialog(errors)}
        </div>
        <ToastContainer style={{ maxHeight: '800px' }} />
      </ACLoader>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBookingsFunc: (filterParams) => dispatch(getBookings(filterParams)),
    getBookingNotificationDataFunc: (bookingId, occasionBookingId) =>
      dispatch(getBookingNotificationData(bookingId, occasionBookingId)),
    getRouteFunc: (routeId) => dispatch(getRoute(routeId)),
    getRoutesByProductIdFunc: (productId) => dispatch(getRoutesByProductId(productId)),
    getVirtualsByProductIdFunc: (productId) => dispatch(getVirtualsByProductId(productId)),
    getUsersFunc: () => dispatch(getUsers()),
    getItemsByProviderIdFunc: (providerId) => dispatch(getItemsByProviderId(providerId, true)),
    getCluesByProviderIdFunc: (providerId) => dispatch(getCluesByProviderId(providerId)),
    getProductByIdFunc: (id) => dispatch(getProductById(id)),
    getItemsFunc: () => dispatch(getItems(true)),

    postPreviewConfirmationFunc: (emailBody) => dispatch(postPreviewConfirmation(emailBody)),
    postSendConfirmationFunc: (emailBody, actorData, bookingId) => dispatch(postSendConfirmation(emailBody, actorData, bookingId)),
    postSendCodeFunc: (codeBody, booking, actorData) => dispatch(postSendCode(codeBody, booking, actorData)),
    postBookingItemPaymentFunc: (bookingId, itemId, data, occasionBookingId) =>
      dispatch(postBookingItemPayment(bookingId, itemId, data, occasionBookingId)),
    postBookingItemActivityFunc: (bookingId, itemId, stopNumber, data, note, occasionBookingId) =>
      dispatch(postBookingItemActivity(bookingId, itemId, stopNumber, data, note, occasionBookingId)),
    postBookingNotificationFunc: (bookingId, confirmationsOrCodes, data) =>
      dispatch(postBookingNotification(bookingId, confirmationsOrCodes, data)),
    patchStopBookingNoteFunc: (bookingId, stopNumber, bookingNote) =>
      dispatch(patchStopBookingNote(bookingId, stopNumber, bookingNote)),
    getStoryboards: (providerId) => dispatch(getStoryboardsByProviderId(providerId)),

    patchBookingFunc: (booking) => dispatch(patchBooking(booking)),
    patchBookingStopsOrderFunc: (booking) => dispatch(patchBookingStopsOrder(booking)),
    putBookingItemPriceFunc: (bookingId, itemId, price, tax, occasionBookingId) =>
      dispatch(putBookingItemPrice(bookingId, itemId, price, tax, occasionBookingId)),
    patchComponentStopProviderItemFunc: (bookingId, itemId, occasionBookingId) =>
      dispatch(patchComponentStopProviderItem(bookingId, itemId, occasionBookingId)),
    putBookingStopFunc: (bookingId, stop, index) =>
      dispatch(putBookingStop(bookingId, stop, index)),
    patchBookingPublishableFunc: (booking, isPublishable, isSwap = false) =>
      dispatch(patchBookingPublishable(booking, isPublishable, isSwap)),
    patchBookingPublishedFunc: (booking, isPublished) =>
      dispatch(patchBookingPublished(booking, isPublished)),
    deleteOneBookingStopProviderFunc: (bookingId, providerId) =>
      dispatch(deleteOneBookingStopProvider(bookingId, providerId)),
    deleteOneBookingStopSparkFunc: (bookingId, sparkId) =>
      dispatch(deleteOneBookingStopSpark(bookingId, sparkId)),

    putBookingManagerFunc: (bookingId, userId, occasionBookingId) =>
      dispatch(putBookingManager(bookingId, userId, occasionBookingId)),
    deleteBookingManagerFunc: (bookingId, occasionBookingId) =>
      dispatch(deleteBookingManager(bookingId, occasionBookingId)),
    putBookingDeliveryStatusFunc: (bookingId, deliveryStatus) => dispatch(putBookingDeliveryStatus(bookingId, deliveryStatus)),
    postBookingMarkAvailableFunc: (bookingId) => dispatch(postBookingMarkAvailable(bookingId)),
    putBookingIsPersonalisedFunc: (bookingId, isPersonalised) => dispatch(putBookingIsPersonalised(bookingId, isPersonalised)),
    deleteOneBookingRouteFunc: (bookingId, occasionBookingId) =>
      dispatch(deleteOneBookingRoute(bookingId, occasionBookingId)),
    deleteOneBookingVirtualFunc: (bookingId, occasionBookingId) =>
      dispatch(deleteOneBookingVirtual(bookingId, occasionBookingId)),

    patchBookingNote: (bookingId, note, dateTime) =>
      dispatch(patchBookingNote(bookingId, note, dateTime)),

    getSparksFunc: (filterParams) => dispatch(getSparks(filterParams)),
    getChallengesBySparkIdFunc: (sparkId) => dispatch(getChallengesBySparkId(sparkId)),
    getCluesBySparkIdFunc: (sparkId) => dispatch(getCluesBySparkId(sparkId)),
  };
};

const mapStateToProps = (state) => {
  const stateBookings = state.bookings;
  const stateStoryBoards = state.storyboards;
  const stateRoutes = state.routes;
  const stateUsers = state.users;
  const stateItems = state.items;
  const stateClues = state.clues;
  const { products = { product: {} } } = state || {};
  const stateVirtuals = state.virtuals || {};
  const stateSparks = state.sparks;
  const stateChallenges = state.challenges;
  const stateNotActiveItems = state.items.notActiveItems;

  let bookings;
  let bookingsCountAll;
  let notificationData;
  let html;
  let refreshBookings;
  let isConfirmationSent;
  let isCodeSent;
  let isBookingNotifyConfirmationSent;
  let isBookingNotifyCodeSent;
  let routes;
  let route;
  let users;
  let items;
  let clues;
  let sparks;
  let challenges;
  let storyBoards;
  let notActiveItems;
  let { product } = products;

  const { virtuals = [], virtual } = stateVirtuals;

  if (stateBookings) {
    refreshBookings = stateBookings.refreshBookings;
    isConfirmationSent = stateBookings.isConfirmationSent;
    isCodeSent = stateBookings.isCodeSent;
    isBookingNotifyConfirmationSent = stateBookings.isBookingNotifyConfirmationSent;
    isBookingNotifyCodeSent = stateBookings.isBookingNotifyCodeSent;

    html = stateBookings.html;

    if (stateBookings.error) {
        console.log({ state });
        var email = stateBookings?.error?.booking?.hq?.customer?.email?.address;
        if (stateBookings.error.shouldDisplay) {
            const { hqId } = stateBookings.error.booking || {};
            toast(
                <div>
                    <div style={{ cursor: 'default' }}>
                        <p>
                            The notification for booking <b>HQ-AEX-{hqId}</b> encountered an error.{' '}
                        </p>
                        <p style={{ fontSize: 'small' }}>
                            Action required - please check in hello@amazingco.me if the email was sent
                            {email ? ` to ${email}` : ''} before resending.
                        </p>
                    </div>
                </div>,
                {
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                }
            );
        }
        console.error({ BookingsError: stateBookings.error });
        clearBookingError();
    }

    if (stateBookings.bookingResponse) {
      bookings = stateBookings.bookingResponse.data;
      bookingsCountAll = Number(stateBookings.bookingResponse.countAll);
    }

    if (stateBookings.notificationDataResponse) {
      notificationData = stateBookings.notificationDataResponse.data;
    }
  }

  if (stateRoutes) {
    if (stateRoutes.error) {
      console.error(stateRoutes.error.message);
    }
    if (stateRoutes.routes) {
      routes = stateRoutes.routes.data;
    }
    if (stateRoutes.route) {
      route = stateRoutes.route.data;
    }
  }

  if (stateUsers) {
    if (stateUsers.error) {
      console.error(stateUsers.error.message);
    }
    if (stateUsers.users) {
      users = stateUsers.users;
    }
  }


  if (stateItems) {
    if (stateItems.error) {
      console.error(stateItems.error.message);
    }
    if (stateItems.items) {
      items = stateItems.items.data;
    }
  }

  if (stateNotActiveItems) {
    if (stateNotActiveItems.error) {
      console.error(stateNotActiveItems.error.message);
    }

    if (stateNotActiveItems.data) {
      notActiveItems = stateNotActiveItems.data;
    }
  }

  if (stateClues) {
    if (stateClues.error) {
      console.error(stateClues.error.message);
    }
    if (stateClues.clues) {
      // TODO: Routes and Virtuals return clues in different formats (one is { data : { data : []  }} the other is { data : [] })
      if (stateClues.clues.data && stateClues.clues.data.length) {
        clues = stateClues.clues.data;
      } else if (stateClues.clues.length) {
        clues = stateClues.clues;
      } else {
        clues = [];
      }
    }
  }
  if (stateStoryBoards) {
    if (stateStoryBoards?.storyboards?.error) {
      console.error(stateStoryBoards.storyboards.error.message);
    }

    if (stateStoryBoards?.storyboards?.data && stateStoryBoards?.storyboards?.data.length > 0) {
      storyBoards = stateStoryBoards.storyboards.data;
    } else {
      storyBoards = []
    }
  }

  if (!isEmpty(products)) {
    if (products.error) {
      console.error(products.error.message);
    }
    if (!isEmpty(product)) {
      product = product.data || {};
    }
  }

  if (stateSparks) {
    if (stateSparks.error) {
      console.error(stateSparks.error.message);
    }
    if (stateSparks.sparks) {
      sparks = stateSparks.sparks;
    }
  }

  if (stateChallenges) {
    if (stateChallenges.error) {
      console.error(stateChallenges.error.message);
    }
    if (stateChallenges.challenges) {
      challenges = stateChallenges.challenges;
    }
  }

  return {
    bookings,
    bookingsCountAll,
    notificationData,
    routes,
    route,
    refreshBookings,
    html,
    isConfirmationSent,
    isCodeSent,
    isBookingNotifyConfirmationSent,
    isBookingNotifyCodeSent,
    users,
    fetching: stateBookings.fetching,
    items,
    clues,
    product,
    virtuals,
    virtual,
    sparks,
    challenges,
    storyBoards,
    notActiveItems
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlannerPage);
